import React, { FC } from 'react'
import { Spinner as ChakraSpinner, SpinnerProps } from '@chakra-ui/react'
import { useColor } from '../../theme'

interface ISpinnerProps {
  size?: Pick<SpinnerProps, 'size'>['size'],
  'data-testid'?: string
}

const Spinner: FC<ISpinnerProps> = ({ size, 'data-testid': testId }) => {
  const spinnerColor = useColor({ nuance: 'blue', palette: 'colors' })
  const spinnerEmptyColor = useColor({ nuance: 3, palette: 'secondary' })

  return (
    <ChakraSpinner
      color={spinnerColor}
      data-testid={testId}
      emptyColor={spinnerEmptyColor}
      size={size ? size : 'xl'}
      speed="1s"
      thickness="4px"
    />
  )
}

export { Spinner }
